// src/utils/errorHandler.ts

export interface BackendErrorResponse {
  code?: string;
  message: string;
  args?: any[];
}

export interface CustomError extends Error {
  message: string;
  code?: string;
  args?: any[];
}

export function extractErrorMessage(error: any): CustomError {
  const customError: CustomError = new Error(
    'Something went wrong',
  ) as CustomError;

  console.log('extract error:', error);
  if (!error.response) {
    // Network or CORS error
    customError.message =
      'Network error, please check your internet connection or try again later';
    return customError;
  }

  const { status, data } = error.response;

  // Prefer the backend's specific message (data.message or a raw string body)
  // for every status. Fall back to a status-specific generic only when the
  // backend gave us nothing useful. Previously this switch hard-coded a
  // generic string for 401/403/500 and threw away meaningful server bodies
  // (e.g. "You don't have the authority to delete this payroll entry" was
  // rendered as "Forbidden. You do not have access to this resource.").
  if (data) {
    if (typeof data === 'object' && 'message' in data) {
      const backendError = data as BackendErrorResponse;
      if (backendError.message) {
        customError.message = backendError.message;
      }
      if (backendError.code) {
        customError.code = backendError.code;
      }
      if (backendError.args) {
        customError.args = backendError.args;
      }
    } else if (typeof data === 'string' && data.length > 0) {
      customError.message = data;
    }
  }

  // If the server gave us nothing parseable, fall back to a status-specific
  // generic so users still see something coherent.
  if (customError.message === 'Something went wrong') {
    switch (status) {
      case 500:
        customError.message = 'Server error, please try again later';
        break;
      case 401:
        customError.message = 'Unauthorized access. Please log in again.';
        break;
      case 403:
        customError.message =
          'Forbidden. You do not have access to this resource.';
        break;
      default:
        break;
    }
  }

  return customError;
}
